import { LevelInitialState } from './../LevelManager/initialState';
import { CharacterElement, CharactersSlice } from './store.d'
import { produce } from 'immer'
import { StateCreator } from 'zustand'
import CharacterConfig from '../../f.assets/Characters/scripts/classes/CharacterConfig'
import { CharactersInitialState } from './initialState'
import { Vector2 } from 'three'
import { CharacterBaseState } from './types'

// store array reference at module level to avoid Redux to serialize many objects and crash
let characterElements: CharacterElement[] = []

export const createCharactersSlice: StateCreator<
  CharactersSlice,
  [['zustand/devtools', never]],
  [],
  CharactersSlice
> = (set, get) => ({
  characters: {
    data: {
      ...CharactersInitialState.data,
    },
    resetCharacters: () => set(
      produce(state => {
        state.characters.data = CharactersInitialState.data
        // state.characters.data.charactersConfig = CharactersInitialState.data.charactersConfig
        // state.characters.data.characterStates = CharactersInitialState.data.characterStates
        // state.characters.data.charactersElementsUUID = []
        // state.characters.data.selectedCharacterUUID = null
      }),
      false,
      { type: 'resetCharacters' },
    ),
    initCharacters: (charactersConfig: CharacterConfig[]) =>
      set(
        produce(state => {
          state.characters.data.charactersConfig = charactersConfig
        }),
        false,
        { type: 'initCharacters' },
      ),
    addCharacterElement: (element: CharacterElement) => {
      characterElements.push(element)
      set(
        produce(state => {
          state.characters.data.charactersElementsUUID.push(element.uuid)
        }),
        false,
        {
          type: 'addCharacterElement',
        },
      )
    },
    // @TODO should destroy elements?
    clearCharacterElement: () => {
      characterElements = []
      set(
        produce(state => {
          state.characters.data.charactersElementsUUID = []
        }),
        false,
        { type: 'clearCharacterElement' },
      )
    },
    setCharacterStates: (states: Record<string, CharacterBaseState>) =>
      set(
        produce(state => {
          state.characters.data.characterStates = states
        }),
        false,
        { type: 'setCharacterStates' },
      ),
    updateCharacterState: (key: string, charState: Record<string, unknown>) =>
      // key is not uuid
      set(
        produce(state => {
          state.characters.data.characterStates[key] = {
            ...state.characters.data.characterStates[key],
            ...charState,
          }
        }),
        // set(
        //   state => ({
        //     characterStates: {
        //       ...state.characterStates,
        //       [key]: {
        //         ...state.characterStates[key],
        //         ...charState,
        //       },
        //     },
        //   }),
        false,
        { type: 'updateCharacterState' },
      ),
    getUuidByCoords: (coords: Vector2) => {
      const state = get()
      return Object.keys(state.characters.data.characterStates).find(uuid => {
        return state.characters.data.characterStates[uuid].coords.equals(coords)
      })
    },
    getCharacterStateByCoords: (coords: Vector2) => {
      const state = get()
      const charUuid = state.characters.getUuidByCoords(coords)
      return charUuid ? state.characters.data.characterStates[charUuid] : undefined
    },
    setSelectedCharacterUUID: (uuid: string) => {
      set(
        produce(state => {
          state.characters.data.selectedCharacterUUID = uuid
        }),
        false,
        { type: 'setSelectedCharacterUUID' },
      )
    },
    clearSelectedCharacterUUID: () => {
      set(
        produce(state => {
          state.characters.data.selectedCharacterUUID = null
        }),
        false,
        { type: 'clearSelectedCharacterUUID' },
      )
    }
  },
})
